import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public currentUser = new Subject<any>();
  constructor() { }
  private subject = new Subject<any>();
  sendClickEvent() {
  this.subject.next;
  }
  
  getClickEvent(): Observable<any>{ 
    return this.subject.asObservable();
  }

  updateUser(data){
    return this.currentUser.next(data);
  }
}
